<template>
  <div>
    <div v-show="loadingData == true" class="ui active inverted dimmer">
      <div class="ui text loader">Cargando</div>
    </div>

    <!--<select @change="getTransportationData"   v-model="index_hotel" class="ui fluid dropdown" placeholder="Hotel para transportación">
            <option  value="" disabled>Seleccione un hotel</option>
            <template v-for="(hotel,index) in hoteles">
                <option :key="index" :value="hotel.Codigo">{{hotel.Nombre}}</option>
            </template>
        </select>-->
    <!-- Paso 1 -->
    <div class="ui form">
      <p class="aboutscroll" style="overflow: hidden; width: auto">
        Type your hotel name
      </p>
      <div v-if="modeEp" class="field fluid">
        <model-select
          :options="comp_hotelesEP"
          v-model="index_ephotel"
          class="use-keyboard-input"
          @searchchange="searchEP"
          placeholder="Select a Hotel"
        >
        </model-select>
      </div>
    </div>
    <!-- end Paso 1 -->

    <br />
    <div v-if="checking" class="ui active dimmer">
      <div class="ui text loader">Checking Price</div>
    </div>
    <div v-if="ProccessStep == 2" class="ui form">
      <div class="ui icon message">
        <i class="taxi icon"></i>
        <div class="content" style="line-height: 25px">
          <div class="header">Transportation Info (approximate times)</div>
          Hotel PickUp: {{ HtlPickup.format("DD-MMM-YYYY HH:mm") }} <br />
          Puerto Cancun Pickup (Return):
          {{ PCGCPickup.format("DD-MMM-YYYY HH:mm") }}<br />
          Travel Time: {{ DuracionViaje }}<br />
          <b v-if="TotalTrans > 0">Total:{{ TotalTrans }} USD</b>
          <b v-if="TotalTrans == 0">Total:Free</b>
        </div>
        <button
          style="float: right"
          class="ui green button"
          type="button"
          @click="saveTransfersBook()"
        >
          Add
        </button>
      </div>
    </div>
  </div>
</template>

<style>
.select2-container {
  width: 100% !important;
}
.vdatetime-input {
  margin: 0;
  max-width: 100%;
  -webkit-box-flex: 1;
  -ms-flex: 1 0 auto;
  flex: 1 0 auto;
  outline: 0;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  text-align: left;
  line-height: 1.21428571em;
  font-family: Lato, "Helvetica Neue", Arial, Helvetica, sans-serif;
  padding: 0.67857143em 1em;
  background: #fff;
  border: 1px solid rgba(34, 36, 38, 0.15);
  color: rgba(0, 0, 0, 0.87);
  border-radius: 0.28571429rem;
  -webkit-transition: border-color 0.1s ease, -webkit-box-shadow 0.1s ease;
  transition: border-color 0.1s ease, -webkit-box-shadow 0.1s ease;
  transition: box-shadow 0.1s ease, border-color 0.1s ease;
  transition: box-shadow 0.1s ease, border-color 0.1s ease,
    -webkit-box-shadow 0.1s ease;
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>

<script>
import { ModelSelect } from "vue-search-select";
import moment from "moment";
import axiosCore from "axios";
const qs = require("querystringify");

export default {
  name: "TransportacionEP",
  components: {
    ModelSelect,
  },
  data() {
    return {
      checking: false,
      URLAPI: "10.147.18.94:84", //www.entertainment-plus.net
      ProccessStep: 1,
      typeTransportation: 4,
      loaded: false,
      editPrice: false,
      loadingData: false,
      hoteles: [],
      index_hotel: "",
      index_ephotel: "",
      Session: "",
      ApiToken: "",
      TotalTrans: 0,
      RowId: "",
      RsvaId: "",
      DuracionViaje: "",
      HtlPickup: "",
      PCGCPickup: "",
      addOn: { transport: "" },
      htime: "",
      gtime: "",
      hotelesEP: [],
    };
  },
  props: ["modeEp", "paxNumber", "prefered", "fecha", "time"],
  methods: {
    async searchEP(searchText) {
      if (searchText != "") {
        let axiosInstance = axiosCore.create({
          headers: {
            "Content-Type": "text/plain",
          },
          transformRequest: (data) => {
            return JSON.stringify(data);
          },
        });
        let urlEp =
          "https://www.entertainment-plus.net/get_hotels_deeplink?term='" +
          searchText +
          " '";
        this.$uvHelper.log(urlEp);
        const response = await axiosInstance.get(urlEp);

        this.hotelesEP = response.data;
      }
    },
    async getEpHotel() {
      let axiosInstance = axiosCore.create({
        headers: {
          "Content-Type": "text/plain",
        },
        transformRequest: (data) => {
          return JSON.stringify(data);
        },
      });
      let urlEp =
        "https://www.entertainment-plus.net/get_hotels_deeplink?term=' '";
      this.$uvHelper.log(urlEp);
      const response = await axiosInstance.get(urlEp);

      this.hotelesEP = response.data;
    },
    enableEditPrice() {
      this.editPrice = true;
    },
    changeTypeTransportation() {
      if (this.typeTransportation == 1) {
        this.TotalTrans = this.getHotelinfoById(this.index_hotel).PrecioRT;
      } else if (this.typeTransportation == 2) {
        this.TotalTrans = this.getHotelinfoById(this.index_hotel).PrecioOWHG;
      } else if (this.typeTransportation == 3) {
        this.TotalTrans = this.getHotelinfoById(this.index_hotel).PrecioOWGH;
      }
    },
    getHotelinfoById(code) {
      let itemIndex = this.$_.findIndex(this.hoteles, { id: code });
      if (itemIndex >= 0) {
        return this.hoteles[itemIndex];
      }

      return false;
    },
    getHotelinfoByCode(code) {
      let itemIndex = this.$_.findIndex(this.hoteles, { Code: code });
      if (itemIndex >= 0) {
        return this.hoteles[itemIndex];
      }

      return false;
    },
    async getHoteles() {
      //obtiene el listado de hoteles afiliados
      await this.$store.getters.getFirebaseApp.database
        .ref("RVA/Mayoristas/Coleccion")
        .on("value", (snapshot) => {
          this.hoteles = [];
          let arrayHoteles = Object.entries(snapshot.val());
          arrayHoteles.forEach((element) => {
            this.hoteles.push({ id: element[0], ...element[1] });
          });
        });
    },
    async getAddons() {
      /*
         Obtiene las temporadas existentes en la db
        */

      const dataTr = await this.$store.getters.getFirebaseApp.database
        .ref("Golf/Addons/Transport")
        .once("value");
      const arrayTr = await dataTr.val();
      this.addOn.transport = arrayTr;
      /*arrayTarifas.forEach((element)=>{
           this.temporadas.push({id:element[0],...element[1]});
        });

        const dataGb = await this.$store.getters.getFirebaseApp.database.ref("Addons/GolfClub").once("value");
        let arrayTarifas =  Object.entries(data.val());
        arrayTarifas.forEach((element)=>{
           this.temporadas.push({id:element[0],...element[1]});
        });*/
    },
    async getTransportationDataEp() {
      if (this.index_ephotel == "") {
        this.$swal({
          title: "Hotel is required",
          text: "Select your hotel",
          icon: "error",
        });
        return false;
      }
      this.checking = true;
      let axiosInstance = axiosCore.create({
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        transformRequest: (data) => {
          return qs.stringify(data);
        },
      });
      let urlEp = "http://" + this.URLAPI + "/ApiReservation/initApi";

      const response = await axiosInstance.post(urlEp, {
        Id: "1663",
        Init: `2sAQXBpUmVzZXJ2YXRpb25FbmNvZGU=AYa`,
      });
      this.ApiToken = response.data.Data.ApiToken;
      this.Session = response.data.Data.Session;

      let dataToAvailability = {
        Token: this.ApiToken,
        Session: this.Session,
        "Data[CHILD_ARRIVAL]": 0, // niños
        "Data[CHILD_DEPARTURE]": 0, // niños
        "Data[MODAL]": 0, //default
        "Data[hotelArrivalId]": this.index_ephotel, //origen - 1er servicio
        "Data[hotelDepartureId]": 2210, //destino - 1er servicio
        //'Data[hotelArrival2]': this.index_ephotel, //origen - 2o servicio (si es round trip)
        //'Data[hotelDeparture2]': 2210, //destino - 2o servicio (si es round trip)
        "Data[TYPE]": "RT", //OW - ONE WAY, RT - ROUND TRIP
        "Data[PAX]": this.paxNumber, // pasajeros
        "Data[PAX_RETURN]": this.paxNumber, //pasajeros normalmente es el mismo
      };

      const responseAvailavility = await axiosInstance.post(
        "http://" + this.URLAPI + "/ApiReservation/checkAvailabilityTransfers",
        dataToAvailability
      );

      if (responseAvailavility.data.Status == "Success") {
        let offset =
          responseAvailavility.data.Data.Avai.ResponseList[0].ServiceList[0]
            .OffSet;
        let hours = Math.floor(offset / 60);
        let minutes = offset % 60;
        (this.RowId = responseAvailavility.data.Data.Avai.Id),
          (this.TotalTrans = responseAvailavility.data.Data.Avai.Total);
        this.DuracionViaje = moment(hours + ":" + minutes, "HH:mm:ss").format(
          "HH [Hrs] : mm [Min]."
        );
        this.HtlPickup = moment(
          this.fecha + " " + this.time,
          "YYYY-MM-DD HH:mm"
        ).subtract(offset, "minutes"); //moment(result.data.data.HtlPickup,'YYYY-MM-DD_HH:mm:ss');
        this.PCGCPickup = moment(
          this.fecha + " " + this.time,
          "YYYY-MM-DD  HH:mm"
        ).add(6, "hours"); //moment(result.data.data.PCGCPickup,'YYYY-MM-DD_HH:mm:ss');
        this.ProccessStep = 2;
      }
      this.checking = false;
    },

    async saveTransfersBook() {
      this.loadingData = true;
      let axiosInstance = axiosCore.create({
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        transformRequest: (data) => {
          return qs.stringify(data);
        },
      });
      let data = {
        Token: this.ApiToken,
        Session: this.Session,
        EditParams: [],
        ROWID: this.RowId,
        VehicleType: "VAN",
        IS_MULTIPLE: "",
        "Data[DATE_ARRIVAL]": this.HtlPickup.format("YYYY-MM-DD"), //fecha llegada - 2020-08-08
        "Data[HR_ARRIVAL]": this.HtlPickup.format("HH:mm"),
        "Data[DATE_DEPARTURE]": this.PCGCPickup.format("YYYY-MM-DD"), //fecha salida - 2020-08-08 => si es rt
        "Data[HR_DEPARTURE]": this.PCGCPickup.format("HH:mm"),
      };

      const response = await axiosInstance.post(
        "http://" + this.URLAPI + "/ApiReservation/TransfersBook",
        data
      );

      this.ProccessStep = 1;
      this.$emit("setData", this.$data);
      this.loadingData = false;
    },

    async getTransportationData() {
      this.loadingData = true;
      /*
        Obiene la informacion de la transportacion para la reserva
        */
      this.$uvHelper.log(this.getHotelinfoById(this.index_hotel), true);
      let data = {
        PaxNumber: this.paxNumber,
        EpHotelId: this.getHotelinfoById(this.index_hotel).Transportacion
          .ExtraParams.EpHotelId,
        DuracionViaje: this.getHotelinfoById(this.index_hotel).Transportacion
          .DuracionViaje,
        Prefered: this.prefered,
        Fecha: this.fecha + "_" + moment(this.time, "HH:mm").format("HH:mm:ss"),
      };

      this.loadingData = true;
      //var getTransportation = this.$store.getters.getFirebaseApp.database.fba.call('Golf-Reservas-transportationAvailability');
      return await this.$store.getters.getFirebaseApp.database.fba
        .call("Golf-Reservas-transportationAvailability", data, {})
        .then((result) => {
          this.$uvHelper.log(result, true);
          this.Session = result.data.data.Session;
          this.ApiToken = result.data.data.ApiToken;
          this.TotalTrans = this.getHotelinfoById(
            this.index_hotel
          ).Transportacion.PrecioRT;
          this.RowId = result.data.data.RowId;
          this.RsvaTransId = result.data.data.RsvaTransId;
          this.rawDuracionViaje = result.data.data.DuracionViaje;
          this.DuracionViaje = moment(
            result.data.data.DuracionViaje,
            "HH:mm:ss"
          ).format("HH [Hrs] : mm [Min].");
          this.HtlPickup = moment(
            result.data.data.HtlPickup,
            "YYYY-MM-DD_HH:mm:ss"
          );
          this.PCGCPickup = moment(
            result.data.data.PCGCPickup,
            "YYYY-MM-DD_HH:mm:ss"
          );
          (this.htime = moment(
            result.data.data.HtlPickup,
            "YYYY-MM-DD_HH:mm:ss"
          ).format("HH:mm")),
            (this.gtime = moment(
              result.data.data.PCGCPickup,
              "YYYY-MM-DD_HH:mm:ss"
            ).format("HH:mm"));
          //this.Confirm= result.data.data.Confirm;
          this.loaded = true;
          this.loadingData = false;
        })
        .catch((error) => {
          this.$uvHelper.log(error);
        });
    },

    async getTransportationDataTest() {
      /*
        Obiene la informacion de la transportacion para la reserva
        */
      /*let data = {
            PaxNumber:this.paxNumber,
            hotelCode:this.index_hotel,
            Prefered:this.prefered,
            Fecha: this.fecha+'_'+moment(this.time,'HH:mm').format('HH:mm:ss') ,

        }*/
      this.loadingData = true;
      //var getTransportation = this.$store.getters.getFirebaseApp.database.fba.call('Golf-Reservas-transportationAvailability');

      this.Session = 53454543534543;
      this.ApiToken = 45435435;
      this.TotalTrans = this.addOn.transport.Precio;
      this.RowId = 432432;
      this.RsvaTransId = 234324;
      this.rawDuracionViaje = "30:00:00";
      this.DuracionViaje = moment("00:30:00", "HH:mm:ss").format(
        "HH [Hrs] : mm [Min]."
      );
      this.HtlPickup = moment("2020-06-01_04:00:00", "YYYY-MM-DD_HH:mm:ss");
      this.PCGCPickup = moment("2020-06-01_06:00:00", "YYYY-MM-DD_HH:mm:ss");
      //this.Confirm= result.data.data.Confirm;
      this.loadingData = false;
      (this.htime = moment("2020-06-01_04:00:00", "YYYY-MM-DD_HH:mm:ss").format(
        "HH:mm"
      )),
        (this.gtime = moment(
          "2020-06-01_06:00:00",
          "YYYY-MM-DD_HH:mm:ss"
        ).format("HH:mm"));
    },
    setData() {
      this.$emit("setData", this.$data);
    },
  },
  computed: {
    initialHour() {
      if (this.htime === "") {
        return this.htime;
      } else {
        let hour = new moment(this.htime);
        //hour.add(10, 'minutes')
        return hour.format("HH:mm");
      }
    },
    comp_hotelesEP() {
      let data_hoteles = [];

      this.hotelesEP.forEach((element) => {
        data_hoteles.push({
          id: element.Id,
          value: element.Id,
          text: element.label,
        });
      });

      return data_hoteles;
    },
    comp_hoteles() {
      let data_hoteles = [];
      this.hoteles.forEach((element) => {
        if (element.ActiTrans) {
          data_hoteles.push({ id: element.id, text: element.Nombre });
        }
      });

      return data_hoteles;
    },
  },
  watch: {
    index_ephotel: function (val) {
      this.getTransportationDataEp();
    },
  },

  beforeMount: function () {},
  mounted: function () {
    this.getAddons();
    this.getHoteles();
    /*if(this.modeEp){
          this.getEpHotel();
      }*/
  },
};
</script>
